export const eatingWayFeatureTranslationJP = {
  EatingWayListPage: {
    head_title: '食べ方一覧',
    add_new: '新規追加',
    detailed: '詳細',
    delete: '削除',
    restore: '復元',
    selection: '選択',
    sale_type_name: '販売タイプ',
    eating_way_name: '食べ方',
    note: '備考',
    menu_book_selection: 'メニューブック選択',
    menu_book_edit: 'メニューブック選択編集',
    warn_confirm_delete: '選択された食べ方を削除します。<br/>よろしいですか？',
    warn_confirm_restore: '選択された食べ方を復元します。<br/>よろしいですか？',
  },
  EatingWayDetailModal: {
    head_title: '食べ方詳細',
    guide_text1: '※表示名は、',
    guide_text2: '日本語以外の言語を選択し、その言語が未設定の場合、英語が表示されます。',
    guide_text3: '※プロパティで、',
    guide_text4: '「食べ放題／飲み放題」。「ピタ放題」を設定した場合、そのコースのオーダー',
    guide_text5: '有無を判断し、未オーダーの場合はコースの紹介画像を表示します。',
    save: '保存',
    sale_type_name: '販売タイプ',
    eating_way_name: '食べ方名',
    property: 'プロパティ',
    head_title_setting_color: 'ジャンルタブ<br/>／サブジャンルタイトル<br/>色設定',
    main_menu_book_note: 'メイン（表示順一番目）メニューブック',
    other_menu_book_note: 'メイン以外メニューブック',
    genre: 'ジャンル',
    subgenre: 'サブジャンル',
    change_text_color: '文字色変更',
    change_background_color: '背景色変更',
    head_title_area_setting: '選択画像',
    area_type_1: '全画面画像',
    area_type_2: '幅1/2画像',
    area_type_3: '幅2/3画像',
    area_type_4: '幅1/3画像',
    area_type_5: '幅1/2高さ1/2画像',
    area_type_6: '幅1/3高さ1/2画像',
    area_type_7: '幅1/4高さ1/2画像',
    note: '備考',
    change: '変更',
  },
  SelectBackgroundModal: {
    head_title: 'ジャンル、サブジャンル背景色詳細',
    color_setting: '■色設定',
    color1: 'カラー1',
    color2: 'カラー2',
    save: '保存',
    change: '変更',
    reset: '初期値に戻す',
    preview: '※表示イメージイメージ',
    main_menu_book: 'メインメニューブック',
    other_menu_book: 'メイン以外メニューブック',
    genre: 'ジャンル',
    subgenre: 'サブジャンル',
  },
  EatingWayAreaImageModal: {
    head_title: '選択画像詳細',
    eating_way: '食べ方',
    property: 'プロパティ',
    image_type: '画像タイプ',
    area_image: '選択画像',
    japanese: '日本語',
    english: '英語',
    simplified_chinese: '中国語（簡体字）',
    transitional_chinese: '中国語（繁体字）',
    korean: '韓国語',
    vietnamese: 'ベトナム語',
    save: '保存',
    change: '変更',
  },
  EatingWaySettingModal: {
    head_title: '食べ方別メニューブック編集',
    add_new: 'メニューブック追加',
    eating_way: '食べ方',
    property: 'プロパティ',
    save: '保存',
    delete: '削除',
    guide_text1: '※並び順の変更について',
    guide_text2: 'メニューブック／コースは選択して、キーボード操作で並び順を変更することができます。',
    guide_text3: '変更すると、モバイルオーダーのメニューブックボタンの並び順が変更になります。',
    selection: '選択',
    selected_menu_book: '選択済メニューブック',
    selected_course: 'コース',
    display_timeframe: '表示する時間帯',
    sale_type: '販売タイプ',
    warning_save_data: 'データが変更されました。<br/>データを保存しますか。',
    warning_invalid_course:
      '設定できる食べ放題／飲み放題のメニューブックは、１つのメニューブックのみです。必ず、１つのメニューブック内のコースを選択してください。',
  },
};
